import { isEqual } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OrderItemType, ServiceOrder } from '@mews-commander/data-access';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import {
    getSelectStateGroupedByServiceOrderSelected,
    toggleGroupedByServiceOrderItemsSelect,
} from '../../../../ducks/billItems';
import {
    getBillOrderItemIdsByServiceOrderId,
    getGroupedByServiceOrderTotal,
    getGroupedByServiceOrderTotalWithoutPayments,
    getGroupedOrderItemsTypes,
    getNestedProductServiceIds,
    getNestedServiceIds,
    getProductServiceOrdersByReservationId,
} from '../../../../selectors';
import { TotalAmountAndCount } from '../../../../types';
import { getBillingGrouping, isAnyOrderItemExpanded } from '../../../../ducks/billing';
import { getBillPaymentIdsWithServiceOrderId } from '../../../../ducks/payments';
import { BillingGrouping } from '../../../../constants';
import { SelectState } from '../types';

interface StateProps {
    totalAmountAndCount: TotalAmountAndCount;
    orderItemTypes: OrderItemType[];
    areAnyOrderItemsHighlighted: boolean;
    reservationPayments: string[];
    selectState: SelectState;
    reservationProductServiceOrders: ServiceOrder[];
}

interface OwnProps {
    serviceId: string;
    serviceOrderId: string;
    billId: string;
    scope: string;
    month: string;
    isRebateScreen: boolean;
}

interface DispatchProps {
    toggleSelect: () => void;
}

export const connectServiceOrderItem = connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        totalAmountAndCount: (
            state: ApplicationState,
            { serviceId, serviceOrderId, billId, month, isRebateScreen, scope }: OwnProps
        ) => {
            const serviceOrderIds = getNestedProductServiceIds(state, {
                reservationId: serviceOrderId,
                serviceOrderId,
                month,
                billId,
            });
            const serviceIds = getNestedServiceIds(state, { reservationId: serviceOrderId, serviceId, month, billId });

            return isRebateScreen || getBillingGrouping(state, { scope }) === BillingGrouping.Month
                ? getGroupedByServiceOrderTotalWithoutPayments(state, { serviceIds, serviceOrderIds, billId, month })
                : getGroupedByServiceOrderTotal(state, { serviceIds, serviceOrderIds, billId, month });
        },
        orderItemTypes: (state: ApplicationState, { serviceId, serviceOrderId, billId, month }: OwnProps) =>
            getGroupedOrderItemsTypes(state, { serviceOrderId, serviceId, billId, month }),
        selectState: (state: ApplicationState, { serviceId, serviceOrderId, billId, scope, month }: OwnProps) => {
            const serviceOrderIds = getNestedProductServiceIds(state, {
                reservationId: serviceOrderId,
                serviceOrderId,
                month,
                billId,
            });
            const serviceIds = getNestedServiceIds(state, { reservationId: serviceOrderId, serviceId, month, billId });

            return getSelectStateGroupedByServiceOrderSelected(state, {
                serviceIds,
                serviceOrderIds,
                billId,
                // @ts-expect-error $TSFixMeError: Argument of type '{ serviceId: string; serviceOrderId: string; billId: string; scope: string; month: string; }' is not a...
                scope,
                month,
            });
        },
        areAnyOrderItemsHighlighted: (state: ApplicationState, props: OwnProps) => {
            const orderItemIds = getBillOrderItemIdsByServiceOrderId(state, props);
            return isAnyOrderItemExpanded(state, { orderItemIds, scope: props.scope });
        },
        reservationPayments: (state: ApplicationState, { serviceOrderId, billId, isRebateScreen }: OwnProps) =>
            isRebateScreen ? [] : getBillPaymentIdsWithServiceOrderId(state, { billId, serviceOrderId }),
        reservationProductServiceOrders: (state: ApplicationState, { serviceOrderId, billId, month }: OwnProps) =>
            getProductServiceOrdersByReservationId(state, { billId, reservationId: serviceOrderId, month }),
    }),
    (dispatch: CommanderThunkDispatch, { serviceId, serviceOrderId, billId, scope, month }) => ({
        toggleSelect: () => {
            const startTime = performance.now();

            dispatch(toggleGroupedByServiceOrderItemsSelect({ serviceId, serviceOrderId, billId, scope, month }));

            const endTime = performance.now();
            // eslint-disable-next-line no-console
            console.log(`Execution time: ${endTime - startTime} milliseconds`);
        },
    }),
    null,
    {
        areStatePropsEqual: isEqual,
    }
);
